import * as React from 'react';

export type ParsedValidTemplateId =
    | { id: number; type: 'builder-template' }
    | { id: string; type: 'buildable-template' };

export type ParsedTemplateId = ParsedValidTemplateId | { type: 'empty' } | { type: 'invalid' };

type UseTemplateIdStateReturns = [
    parsedId: ParsedTemplateId,
    setParsedId: React.Dispatch<React.SetStateAction<ParsedTemplateId>>,
];

export function useTemplateIdState(initialParsedId: ParsedTemplateId): UseTemplateIdStateReturns {
    return React.useState<ParsedTemplateId>(initialParsedId);
}
